import { m } from 'motion/react';
import { components, type MenuProps } from 'react-select';

import type { TOption } from '../types';

export const CustomMenu = (props: MenuProps<TOption>) => {
  return (
    <m.div
      initial={{ scale: 0.9, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      exit={{ scale: 0.9, opacity: 0 }}
      transition={{ duration: 0.15, ease: [0.4, 0, 0.2, 1] }}
    >
      <components.Menu {...props} />
    </m.div>
  );
};
